import { takeEvery, put, call, fork } from 'redux-saga/effects';

import { Client } from '../../utils/client';
import { SPORTS_LOAD, sportsLoadSuccess } from './actions';
import { setError } from '../../redux-root/actions';

export function* sportsLoad(action) {
  const { platformType } = action;

  try {
    const sportsData = yield call(Client.getData, `/pages/handles/sports?platformType=${encodeURIComponent(platformType)}`);

    yield put(sportsLoadSuccess(sportsData.data));
  } catch (error) {
    console.log(error);

    yield put(setError('General Errors', `It's not you. It's us. We are working to fix this...`, error));
  }
}

function* watchSportsLoad() {
  yield takeEvery(SPORTS_LOAD, sportsLoad);
}

export function* sportsSaga() {
  yield fork(watchSportsLoad);
}
